import React, { Component } from 'react'

import { useSelector, useDispatch } from 'react-redux';

import StreamCard from '../Cards/StreamCard'
import { StreamState, Stream } from '../../../../../types';
import HomepageSection from '../HomepageSection';

export default function ActualStreams() {
    const streams = useSelector( (state: StreamState) => { return state.streams } )

    const CardsRendered = streams.map( card => <StreamCard props={card}/>)
    return <HomepageSection>{CardsRendered}</HomepageSection>;
}

